<template>
  <div class="shedMonitorNew" ref="shedMonitorNew">
    <div class="tltle">
      <div class="home_number">{{ options.length }}</div>
      <el-select v-model="shedNo" filterable placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.shedNo"
          :label="item.shedName"
          :value="item.shedNo"
        >
        </el-option>
      </el-select>
    </div>
    <div class="monitor" @click="redirectToDetail()">
      <el-tabs type="border-card">
        <template v-for="(item, n) in videoList" v-bind:key="n + '#' + item.videoNo">
          <el-tab-pane :label="item.videoNo">
            <img :src="item.videoUrl" class="vdm-image" />
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
    <div class="PM-chart" ref="chart"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  inject: ["updateMaterialArea"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
      options: [],
      value: "",
      shedNo: "",
      videoList: [],
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    shedNo: {
      handler(newVal, oldVal) {
        this.getShedVideosResult();
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.shedMonitorNew).outerWidth();
    let h = $(that.$refs.shedMonitorNew).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    //this.getData();
    //debugger;
    this.getShedListResult();
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  //方法集合
  methods: {
    redirectToDetail(){
     this.updateMaterialArea(this.options[0]);
    },
    async getShedListResult() {
      this.options = await this.getShedList();
      if (this.options.length > 0) {
        this.shedNo = this.options[0]["shedNo"];

        this.getShedVideosResult();
      }
    },
    async getShedVideosResult() {
      this.videoList = await this.getShedVideos();
    },
    async getShedList() {
      let that = this;
      return new Promise(function (resolve, reject) {
        let findShedListUrl = CONFIG.requestName + that.$apiOpt.findShedList;
        that.$apiUtils
          .get(findShedListUrl, {
            customerId: that.$store.state.customerId,
          })
          .then(function (data) {
            resolve(data);
          });
      });
    },
    async getShedVideos() {
      let that = this;
      return new Promise(function (resolve, reject) {
        let findShedVideosUrl = CONFIG.requestName + that.$apiOpt.findShedVideos;
        that.$apiUtils
          .get(findShedVideosUrl, {
            shedNo: that.shedNo,
          })
          .then(function (data) {
            resolve(data);
          });
      });
    },
    async getData() {
      let _this = this;
      this.pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let data = await _getEasyNvr("/newscreen/env/getAllHistoryByType", {
        customerId: _this.customerId,
        unit: _this.unit,
      });
      data.forEach((x, index) => {
        let { x_data, day_time, pm10_avg_value, pm25_avg_value } = x;
        if (day_time && day_time.indexOf(" ") != -1) {
          day_time = day_time.split(" ")[1];
        }
        if (pm10_avg_value || pm25_avg_value) {
          this.noData = false;
        }
        this.pmData.xData.push(day_time);
        this.pmData.y1Data.push(pm10_avg_value);
        this.pmData.y2Data.push(pm25_avg_value);
      });
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = echarts.init(this.$refs.chart);
        }
        let optionStr = getOpt(this.pmData);
        unwarp(this.chart).setOption(optionStr);
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.shedMonitorNew {
  .monitor {
    //@include bg-box(560px, 230px, "1.png");
    //margin: 29px auto 15px;
    position: absolute;
    bottom: 10px;
    top: 60px;
    left: 20px;
    right: 20px;

    .el-tabs--border-card {
      background: initial !important;
      border: initial !important;
    }

    .el-tabs--border-card > .el-tabs__header {
      background: initial !important;
      border: initial !important;
    }

    .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      background: #2dacd24d !important;
      border: initial !important;
      color: #65f5f2 !important;
      font-family: "normalFont";
    }

    .el-tabs__content {
      height: calc(100% - 53px);
      position: absolute;
      padding: 15px 0;
      width: 100%;
      overflow: auto;
      .vdm-image {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss" scoped="scoped">
.shedMonitorNew {
  width: 600px;
  height: 520px;
  .tltle {
    display: flex;
    height: 24px;
    justify-content: flex-end;
    .home_number {
      margin-right: 166px;
    }
  }

  .PM-chart {
    width: 100%;
    height: 150px;
    position: relative;
    margin: 0 auto;
  }

  .vdm-image {
    position: relative;
    height: calc(100% - 100px);
  }
}
</style>
